import { useMutation, useQueryClient } from 'react-query';

import { PromptTemplateScope } from '../../../../backend/src/prompt-template/dto/prompt-template.constants';
import { PromptTemplateResponseDto } from '../../../../backend/src/prompt-template/dto/prompt-template.response.dto';
import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

interface UpdatePromptTemplateParameters {
  id: string;
  matterId?: string;
  title?: string;
  body?: string;
}

export const useUpdatePromptTemplate = (
  matterId: string | undefined,
  scope: PromptTemplateScope = PromptTemplateScope.Personal,
) => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation<PromptTemplateResponseDto, Error, UpdatePromptTemplateParameters>(
    async ({ id, matterId: templateMatterId = matterId, title, body }) => {
      const fetchConfig = getFetchConfig({
        method: FetchMethod.PATCH,
        // Organisation-scoped templates are not tied to a matter.
        data: {
          title,
          body,
          scope,
          matterId: scope === PromptTemplateScope.Organisation ? undefined : templateMatterId,
        },
      });

      const res = await fetch(`${APIBaseChronos}/api/prompt-template/${id}`, fetchConfig);

      if (!res.ok) throw new Error('Updating prompt template failed');
      return res.json();
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([QueryEntity.PromptTemplates]);
      },
    },
  );
};
